export const chartColorList = [
    '#8230ff', // purple (hsl(257, 86%, 51%))
    '#b28cff', // light-purple (hsl(257, 86%, 70%))
    '#2563eb', // blue (hsl(220, 90%, 56%))
    '#27dbe7', // cyan (hsl(190, 75%, 50%))
    '#2dac4b', // green (hsl(140, 60%, 45%))
    '#ffc800', // yellow (hsl(45, 100%, 50%))
    '#ff6a00', // orange (hsl(30, 100%, 55%))
    '#f45e45', // coral (hsl(15, 85%, 60%))
    '#f75a75', // rose (hsl(350, 80%, 60%))
    '#5040a0', // indigo (hsl(250, 40%, 40%))
    '#63e2b7', // mint (hsl(160, 70%, 60%))
    '#1fc7c1', // teal (hsl(185, 80%, 45%))
    '#f08ccd', // pink (hsl(330, 70%, 65%))
    '#90baff', // light-blue (hsl(210, 90%, 70%))
    '#b5f32f', // lime (hsl(90, 70%, 55%))
];
